import { CustomQueryOptions } from '@/common/types_and_interfaces.ts'
import { queryOptions } from '@tanstack/react-query'
import { PaginatedPublicPrograms } from '@/apis/programs/programs.ts'
import { RolesKeys } from './query_key_factory.ts'
import { getRolePermissionsDetail } from './roles.ts'
import { getRoles } from './roles.ts'
import { RolePermissionList } from './schemas.ts'

export class RoleQueries {
  public static index(
    programId: number = 0,
    options: CustomQueryOptions<PaginatedPublicPrograms> = {}
  ) {
    return queryOptions({
      queryKey: [RolesKeys.allRoles, programId] as const,
      queryFn: () => getRoles(programId ?? 0),
      ...options,
    })
  }

  public static getRolePermissionsByRoleId(
    roleId: number = 0,
    options: CustomQueryOptions<RolePermissionList> = {}
  ) {
    return queryOptions({
      queryKey: RolesKeys.permissionsByRoleId(roleId!),
      queryFn: () => getRolePermissionsDetail(roleId ?? 0),
      ...options,
    })
  }
}
